import { JsonObject } from '../app/json/jsonObject.js';
import { ResourceStatistics } from './resourceStatistics.js';

export class TemplateEntry {
    html: string;
    json: JsonObject | null;

    constructor(html: string = '', json: JsonObject | null = null) {
        this.html = html;
        this.json = json;
    }

    get Html(): string {
        return this.html;
    }

    get Json(): JsonObject | null {
        return this.json;
    }
}

type TemplateStoreMap = Map<string, TemplateEntry>;

export class TemplateStore {
    _appSiteCache: Map<string, TemplateStoreMap> = new Map();
    _resourceStatsCache: Map<string, ResourceStatistics> = new Map();

    hasAppSite(appSite: string): boolean {
        for (const cachedAppSite of this._appSiteCache.keys()) {
            if (cachedAppSite === appSite) {
                return true;
            }
        }
        return false;
    }

    tryGetTemplates(appSite: string): TemplateStoreMap | undefined {
        if (!this._appSiteCache.has(appSite)) {
            return undefined;
        }

        return this._appSiteCache.get(appSite);
    }

    getTemplates(appSite: string): TemplateStoreMap | undefined {
        if (!this._appSiteCache.has(appSite)) {
            return undefined;
        }

        return this._appSiteCache.get(appSite);
    }

    AddAppSite(appSite: string, templates: TemplateStoreMap): boolean {
        if (!this._appSiteCache.has(appSite)) {
            this._appSiteCache.set(appSite, templates);
            return true;
        }
        return false;
    }

    setTemplates(appSite: string, templates: TemplateStoreMap): void {
        if (this._appSiteCache.has(appSite)) {
            this._appSiteCache.delete(appSite);
        }
        this._appSiteCache.set(appSite, templates);
    }

    getAllAppSites(): Map<string, TemplateStoreMap> {
        return this._appSiteCache;
    }

    getAppSiteCount(): number {
        return this._appSiteCache.size;
    }

    tryGetResourceStats(appSite: string): ResourceStatistics | undefined {
        if (!this._resourceStatsCache.has(appSite)) {
            return undefined;
        }

        return this._resourceStatsCache.get(appSite);
    }

    setResourceStats(appSite: string, stats: ResourceStatistics): void {
        if (this._resourceStatsCache.has(appSite)) {
            this._resourceStatsCache.delete(appSite);
        }
        this._resourceStatsCache.set(appSite, stats);
    }

    clear(): void {
        this._appSiteCache.clear();
        this._resourceStatsCache.clear();
    }
}
